import { render, staticRenderFns } from "./TabbedIntegrationSettings.vue?vue&type=template&id=1ed95ba1&scoped=true"
import script from "./TabbedIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./TabbedIntegrationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed95ba1",
  null
  
)

export default component.exports